import React, { useState, useEffect } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import BannerSlider from "../components/BannerSlider";
import PharmacyCategories from "../components/PharmacyCategories";
import SpecialOffers from "../components/SpecialOffers/SpecialOffers";
import TopProducts from "../components/SpecialOffers/TopProducts/TopProducts";
import TripleBannerSlider from "../components/TripleBannerSlider";
import FeaturesSection from "../components/FeaturesSection";
import BrandCarousel from "../components/BrandCarousel";
import FreeShippingBanner from "../components/FreeShippingBanner";
import novalac from "../assets/banners/NovalacPromocija5+1.png";
import drB from "../assets/banners/DrLuigiBanner.png";
import hydroA from "../assets/banners/hydroA.png";
import kd from "../assets/banners/kd.jpg";

import e from "../assets/banners/Eucerin_1350x1080 (1).png";
import pro from "../assets/banners/probielle.png";

import e30 from "../assets/banners/ecurin30.png";
import e25 from "../assets/banners/e25.png";
import u from "../assets/banners/urasan.png";

const banners = [
  {
    image: drB,
    alt: "Skincare proizvodi",
    filters: {
      brand: "Dr. Luigi",
    },
  },
  ///////////////////////////////////////////////////////////////////////////////////////
  {
    image: u,
    alt: "Novo u ponudi",
    filters: {
      brand: "Bioclinica",
    },
  },
  {
    image: novalac,
    alt: "Novo u ponudi",
    filters: {
      productName: "5+1",
    },
  },

  {
    image: kd,
    alt: "Novo u ponudi",
    filters: {
      brand: "Abela Pharm",
    },
  },
  
  {
    image: novalac,
    alt: "Novo u ponudi",
    filters: {
      productName: "5+1",
    },
  },
    {
    image: u,
    alt: "Novo u ponudi",
    filters: {
      brand: "Bioclinica",
    },
  },
  
  {
    image: kd,
    alt: "Novo u ponudi",
    filters: {
      brand: "Abela Pharm",
    },
  },
  
];

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      style={{
        fontFamily: "'Arial', sans-serif",
        color: "#333",
        lineHeight: 1.6,
        backgroundColor: "#FAF1E6",
      }}
    >
      {isMobile ? (
        <BannerSlider banners={banners.slice(1, 11)} />
      ) : (
        <TripleBannerSlider banners={banners.slice(1, 11)} />
      )}

      <PharmacyCategories />
      <SpecialOffers />

      {/* Prvi TripleBannerSlider - koristi prve 3 bannera */}

      {!isMobile && <BannerSlider banners={banners.slice(0, 1)} />}

      {/* Drugi TripleBannerSlider - koristi sledeće 3 bannera (ako postoje)
     {banners.length > 3 && (
         <TripleBannerSlider banners={banners.slice(3, 6)} />*/}
      <FreeShippingBanner />

      <FeaturesSection />
      <TopProducts />
      {/*<ComboOffer
        product1={{
          image: "/putanja/do/slike1.jpg",
          name: "Proizvod 1",
        }}
        product2={{
          image: "/putanja/do/slike2.jpg",
          name: "Proizvod 2",
        }}
        comboPrice={299}
        regularPrice={399}
      />
      <BigComboProduct
        product1={{
          image: "/putanja/do/slike1.jpg",
          name: "Premium Proizvod 1",
        }}
        product2={{
          image: "/putanja/do/slike2.jpg",
          name: "Premium Proizvod 2",
        }}
        comboPrice={49}
        regularPrice={69}
      />
      <MiniProduct />
      {/* Ovde možeš dodati druge sekcije kao featured products itd. */}
      <BrandCarousel />
      <Footer />
    </div>
  );
};

export default HomePage;
